import { useQuery } from 'react-query';
import { getApi } from '../../../../../config/SwaggerApi';
import configQueryReactSimpleRequest from '../../../config/configQuery';

// todo fix this
const fetchPoiFn = (workspaceName: string) =>
    getApi().asite.asiteGetCustomPoiByWorkspaceNameGet({
        WorkspaceName: workspaceName,
    }).then((response) => response.data);

const useGetCustomPoiByWorkspaceName = (workspaceName: string) => {

    const customPoiByProjectIdQuery = useQuery(
        ['poi-by-workspace-name', workspaceName],
        () => fetchPoiFn(workspaceName),
        { ...configQueryReactSimpleRequest, enabled: !!workspaceName },
    );

    return customPoiByProjectIdQuery;
};

export default useGetCustomPoiByWorkspaceName;
